import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import PropTypes from 'prop-types'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { toFilter } from 'utils/widgetUtil'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { createSearches } from './utils'

interface RunSearchEffectProps {
  widgetId: number
  isAudienceQuery: boolean
  children: React.ReactElement
}

const useRunSearch = (widgetId: number, isAudienceQuery: boolean) => {
  const dispatch = useAppDispatch()
  const widgetSetting = useDashboardWidgetSetting(widgetId)
  const dashboardData = useDashboardData()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const filter = toFilter(widgetSetting)
    const searches = createSearches(widgetSetting, dashboardData!, filter, isAudienceQuery)
    dispatch(getWidgetForDashboard({ widgetId, searches, timestamp: refreshTimestamp }))
  }, [widgetId, widgetSetting, dashboardData, isAudienceQuery, dispatch, refreshTimestamp])
}

const RunSearchEffect = ({ widgetId, isAudienceQuery, children }: RunSearchEffectProps) => {
  useRunSearch(widgetId, isAudienceQuery)
  return children
}

RunSearchEffect.propTypes = {
  widgetId: PropTypes.number.isRequired,
  isAudienceQuery: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]).isRequired
}

RunSearchEffect.defaultProps = {
  isAudienceQuery: false
}

export default RunSearchEffect
